import { getSubscriptionCenterWidgetConfig } from './widgets/SubscriptionCenter/widgetConfig';
import { getSubscriptionTipsWidgetConfig } from './widgets/SubscriptionTips/widgetConfig';
import { getTierContentWidgetConfig } from './widgets/TierContent/widgetConfig';
import { getTiersWidgetConfig } from './widgets/Tiers/widgetConfig';
import getCoverDeviationWidgetConfig from '../../UserWidgets.deviation_gruser/CoverDeviation/widgetConfig';

// TODO: section widget configs need to be standardized, some configs are keyed
// by zoneName, some by moduleName, and some arbitrary like this one
export const getSubscriptionWidgetConfigs = ({ t, dispatch }) =>
  ({
    ownerDesktop: {
      coverDeviation: getCoverDeviationWidgetConfig({ t, dispatch }),
      subscriptionCenter: getSubscriptionCenterWidgetConfig({ t, dispatch }),
      subscriptionTips: getSubscriptionTipsWidgetConfig({ t, dispatch }),
    },
    ownerMobile: {
      coverDeviation: getCoverDeviationWidgetConfig({ t, dispatch }),
      subscriptionCenter: getSubscriptionCenterWidgetConfig({ t, dispatch }),
    },
    mainContent: {
      tiers: getTiersWidgetConfig({ t, dispatch }),
      tierContent: getTierContentWidgetConfig({ t, dispatch }),
    },
  } as any);
